let useCache = undefined;

export const isUseIDBCache = (): boolean => {
	if (useCache === undefined) {
		const msg = "Use IDB Cache not configured yet";
		console.error(msg);
		throw Error(msg);
	}
	return useCache;
};

export const setUseIDBCache = (useIDBCacheParameter: boolean) => {
	useCache = useIDBCacheParameter;
};
